import UsersAndGroupList from '@/app/usersAndGroups'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { ability } from '@/casl/ability'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import TableSkeleton from '@/components/table-skeleton'
import { usersByCompanyIdQueryOptions } from '@/hooks/useUsersQuery'
import LocalStorage from '@/utilities/LocalStorage'

const RouteComponent = () => {
  return <UsersAndGroupList />
}

export const Route = createFileRoute('/_auth/_withProject/users')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Kullanıcılar')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.prefetchQuery(usersByCompanyIdQueryOptions(companyId))
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


